import React from 'react';
import { FC, useCallback, useMemo, useState } from 'react';
import { Button, Message } from '@bedrock/components';
import { Download } from '@bedrock/icons-react';
import {
  PartnershipRequestInvoker,
  SupplierRequestInvoker,
  FormItemAttachmentType,
} from '@purchase/supplier';
import { downloadFile } from '#utils/download';

interface DownloadAllButtonProps {
  formDetail?: any;
  isExternal?: boolean;
}

/**
 * 下载全部附件按钮
 * 从相关材料中提取所有 attachmentFiles，并发请求下载链接后逐个下载
 */
const DownloadAllButton: FC<DownloadAllButtonProps> = ({
  formDetail,
  isExternal = false,
}) => {
  const [loading, setLoading] = useState(false);

  // 支持多附件，过滤掉禁止下载的附件类型（如公司负责人身份证正反面）
  const attachments =
    formDetail?.vendorAttachmentInfo?.otherAttachments
      ?.filter(
        (attachment: any) =>
          attachment?.attachmentType !==
          FormItemAttachmentType.Type.LegalRepresentativeIdCardCopy
      )
      ?.flatMap(
        (attachment: any) =>
          attachment?.attachmentFiles?.filter((file: any) => !!file?.id) ?? []
      ) ?? [];

  const handleDownloadAll = async () => {
    setLoading(true);
    try {
      const getDownloadUrl = isExternal
        ? PartnershipRequestInvoker.getInstance()
            .partnerShipOpenApiAttachmentDownloadUrl
        : SupplierRequestInvoker.getInstance()
            .vendorAttachmentGetAttachmentDownloadUrl;

      const results = await Promise.all(
        attachments.map((file) => getDownloadUrl({ fileId: file.id }))
      );

      results.forEach((res) => res?.data && downloadFile(res.data));
    } catch {
      Message.error('下载失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  if (!attachments.length) return null;

  return (
    <div className="flex items-center">
      <Button
        type="link"
        size="xSmall"
        icon={<Download />}
        loading={loading}
        onClick={handleDownloadAll}
      >
        下载全部
      </Button>
    </div>
  );
};

export default DownloadAllButton;
